import React from 'react';
import FooterContainer from './footer.styles';

const Footer = () => (
  <FooterContainer>
    Copyright © 2020 Ella Clothings. All rights reserved.
  </FooterContainer>
);

export default Footer;
